var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"line","height":_vm.height || '350vh',"options":_vm.chartOptions,"series":_vm.series},on:{"update:options":function($event){_vm.chartOptions=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }